export default __webpack_public_path__ + "static/sampling_attributes-d17f0bb4af5af7ba3f6f34c8262249f7.png";